import * as ko from "knockout";
import * as $ from "jquery";
import BaoUtils from "./../services/bao-utils";
let bindingName = "validate";
let defaults: Bindings.validate = {
    element: null,
    enabled: ko.observable(true),
    type: "required",
    value: ko.observable(null),
    css: {
        iconvalid: "",
        iconinvalid: "fa-exclamation-circle",
        valid: "",
        invalid: "has-error"
    },
    text: "",
    regex: null,
    numberMin: null,
    numberMax: null,
    numberRequired: false
};
export class ValidateExtender implements KnockoutValidateExtender {
    constructor(target: KnockoutObservable<any>, validateBinding: Bindings.validate) {
        this._target = target;
        this.config = $.extend({}, defaults, validateBinding);
        this._sub = target.subscribe(() => {
            this._target.validate.update(false);
        });
    }
    private _sub: KnockoutSubscription;
    private _target: KnockoutObservable<any>;
    config: Bindings.validate;
    status = ko.observable<boolean>(true);
    update(setFocus?: boolean): boolean {
        if (this.config.enabled == undefined || this.config.enabled() == true) {
            switch (this.config.type.toLowerCase()) {
                case "email":
                    this._handleEmail();
                    break;
                case "regex":
                    this._handleRegex(ko.unwrap(this.config.regex));
                    break;
                case "number":
                    this._handleNumber(ko.unwrap(this.config.numberMin), ko.unwrap(this.config.numberMax), ko.unwrap(this.config.numberRequired));
                    break;
                case "required":
                default:
                    this._handleRequired();
                    break;
            }
        }
        else {
            this.status(true);
        }
        if ((setFocus == null || setFocus == true) && this.status() == false) {
            $(this.config.element()).focus();
        }
        return this.status();
    }
    ;
    dispose() {
        this._sub.dispose();
    }
    private _handleRequired() {
        var validateResult = this._target() != null;
        if (typeof this._target() === "string") {
            validateResult = !BaoUtils.String.IsNullOrWhitespace(this._target());
        }
        this.status(validateResult);
    }
    private _handleEmail() {
        var reg = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        this._handleRegex(reg);
    }
    private _handleRegex(reg: RegExp) {
        var input = this._target();
        this.status(reg.test(input));
    }
    private _handleNumber(min: number, max: number, required: boolean) {
        let validateResult = true;
        let input = this._target();
        if (required == true) {
            validateResult = this._target() != null;
            if (typeof this._target() === "string") {
                validateResult = !BaoUtils.String.IsNullOrWhitespace(this._target());
            }
        }
        if (validateResult == true && input != null) {
            if (min != null) {
                if (input < min) {
                    validateResult = false;
                }
            }
            if (max != null) {
                if (input > max) {
                    validateResult = false;
                }
            }
        }
        this.status(validateResult);
    }
}
export class ValidateBinding {
    constructor(element: HTMLElement, valueAccessor: () => Bindings.validate, viewModel: any) {
        this.Element = element;
        this.ValueAccessor = valueAccessor;
        let validateConfig: Bindings.validate = $.extend({}, defaults, valueAccessor());
        if (validateConfig.element == undefined || validateConfig.element == null) {
            validateConfig.element = ko.observable(element);
        }
        this.ValueAccessor().value.extend({ validate: validateConfig });
        //gui stuff only for textbox, textarea
        if ($(this.Element).is("input[type='text'], textarea")) {
            if (!$(this.Element).parent().is("div.has-feedback")) {
                $(this.Element).wrap("<div class='has-feedback'></div>");
            }
            if (!$(this.Element).next().is(".form-control-feedback")) {
                $(this.Element).after("<span class='form-control-feedback fa'></span>");
            }
            this.Container = $(this.Element).parent()[0];
            this.ValidationElement = $(this.Element).next()[0];
            $(this.Container).css("max-width", $(this.Element).css("max-width"));
        }
        else {
            this._noGuiMode = true;
        }
        $(this.Element).data(bindingName, this);
        if (viewModel != null && viewModel.validate === undefined) {
            viewModel.validate = this.ValidateViewModel;
        }
    }
    private _noGuiMode = false;
    ValidateViewModel(): boolean {
        var result = true;
        let vm = <any>this;
        vm.validateMessage = [];
        for (var k in vm) { //this bezieht sich auf das ViewModel
            if (ko.isObservable(vm[k]) && vm[k].validate != null) {
                var validator: KnockoutValidateExtender = vm[k].validate;
                validator.update();
                if (validator.status() == false) {
                    vm.validateMessage.push(ko.unwrap(validator.config.text));
                    result = false;
                }
            }
        }
        return result;
    }
    Element: HTMLElement;
    Container: HTMLElement;
    ValidationElement: HTMLElement;
    ValueAccessor: () => Bindings.validate;
    Config: () => Bindings.validate = () => {
        let validateConfig: Bindings.validate = $.extend({}, defaults, this.ValueAccessor());
        return validateConfig;
    };
    setCss() {
        let cfg = this.Config();
        if (this._noGuiMode == false) {
            if (this.ValueAccessor().value.validate.status()) {
                //valid
                $(this.Container).removeClass(cfg.css.invalid).addClass(cfg.css.valid);
                $(this.ValidationElement).removeClass(cfg.css.iconinvalid).addClass(cfg.css.iconvalid);
            }
            else {
                //invalid
                $(this.Container).removeClass(cfg.css.valid).addClass(cfg.css.invalid);
                $(this.ValidationElement).addClass(cfg.css.iconinvalid).removeClass(cfg.css.iconvalid);
            }
        }
    }
    dispose() {
        this.ValueAccessor().value.validate.dispose(); //dispose extender
        $(this.Element).removeData(bindingName);
    }
}
//Knockout register logic for binding and extender
var binding: KnockoutBindingHandler = {
    init: function (element: HTMLElement, valueAccessor, allBindingsAccessor, viewModel) {
        var bindingInstance = new ValidateBinding(element, valueAccessor, viewModel);
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            bindingInstance.dispose();
        });
    },
    update: function (element: HTMLElement, valueAccessor: () => Bindings.validate) {
        valueAccessor().value.validate.update(false);
        var bindingInstance: ValidateBinding = $(element).data(bindingName);
        if (bindingInstance != null) {
            bindingInstance.setCss();
        }
    },
    after: ["baoAutoComplete", "baoSearcher", "baoDateTimePicker"]
};
ko.bindingHandlers[bindingName] = binding;
ko.extenders.validate = function (target: KnockoutObservable<any>, validateBinding: Bindings.validate) {
    if (target.validate == undefined) {
        target.validate = new ValidateExtender(target, validateBinding);
    }
    return target;
};